import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

const SeoSection = (): ReactElement => {
  const { t: tSeo } = useTranslation('', { keyPrefix: '$pages.$home.$seoSection' });

  return (
    <section className="base-section seo-section hp-section">
      <div className="seo-copy clearfix">
        <div>
          <picture>
            <img
              src="/images/homepage/renaissance-hotels-travels.webp"
              alt="Renaissance Hotels Travels"
              className="travel-desk"
              width={720}
              height={603}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
        </div>
        <div className="clearfix">
          <h2>{tSeo('seoHeader')}</h2>
          <span>
            <picture>
              <source
                srcSet="/images/homepage/renaissance-hotels-travels.webp"
                media="(min-width: 769px)"
              />
              <source
                srcSet="/images/homepage/renaissance-hotels-travels-tab.webp"
                media="(min-width: 661px)"
              />
              <img
                src="/images/homepage/renaissance-hotels-travels-mob.webp"
                alt="Travels"
                className="travel-mob"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
            </picture>
          </span>
          <p>{tSeo('seoCopy')}</p>
        </div>
      </div>
    </section>
  );
};

export default SeoSection;
